<template>
  <div id="Home">
    <section>
      <h3>Vision of MGSC</h3>
      <hr />
      <div id="vision">
        The vision of Modeling Geographical Systems Commission (MGSC) of
        International Geographical Union (IGU) is to share an interest in
        developing the theories, dynamics, simulation and decision-making of
        geographical systems using statistical and mathematical approaches, and
        further to enhance research on modeling and simulation methods and other
        technological advances for geographic pattern analysis and process
        exploration.
      </div>
    </section>

    <section class="latest-news">
      <h3>Latest News</h3>
      <hr />
      <article
        v-for="(event, index) in latestNews"
        :key="event.route"
        class="news-item"
      >
        <router-link :to="event.route">
          <strong class="home-h">{{ event.title }}</strong>
        </router-link>
        <p>{{ event.summary }}</p>
        <p>
          The abstract follows:
          <router-link :to="event.route">(more…)</router-link>
        </p>
        <hr
          v-if="index < latestNews.length - 1"
          class="news-divider"
        />
      </article>
    </section>

    <el-backtop :visibility-height="1400"></el-backtop>
  </div>
</template>

<script>
import { latestNews as allNews } from '../data/events';

export default {
  name: 'Home',
  data() {
    return {
      latestNews: allNews.slice(0, 10)
    };
  }
};
</script>

<style lang="less" scoped>
#Home {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

hr {
  border: 0.1px solid #eeeeee;
}

#vision {
  line-height: 2.1rem;
  margin-bottom: 2rem;
}

.news-item {
  margin-top: 1rem;
}

.news-divider {
  border-bottom: 3px double grey;
  margin-top: 1.5rem;
}

.home-h {
  font-size: 1.2rem;
  display: block;
  font-weight: bolder;
}

.home-date {
  display: block;
  color: grey;
  font-weight: bold;
}

a {
  color: #1a80b6;
  font-size: 1.2rem;
  text-decoration: none;
}
</style>
